import { Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API, API_ROUTES } from '@app/shared/utils/api-routes';
import { environment } from '@environments/environment';
import { Contract, ContractCsvRow } from '@app/shared/interfaces/contract.interface';
import { createHttpParams } from '@app/shared/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class ContractService {
  constructor(private httpClient: HttpClient) {}

  public getContracts(params: { [key: string]: string }): Observable<Contract[]> {
    return this.httpClient
      .get(`${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.CONTRACTS}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        params: createHttpParams(params),
      })
      .pipe(map((res) => res)) as Observable<Contract[]>;
  }

  public getContractsInvoices(params: {
    startDate?: string;
    endDate?: string;
    selectedFilter?: string;
    fieldSearch?: string;
  }): Observable<ContractCsvRow[]> {
    return this.httpClient.get<ContractCsvRow[]>(
      `${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.CONTRACTS_INVOICES}`,
      {
        params,
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }
}
